module.exports = __webpack_public_path__ + "img/color.cc777287.png";